/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiEmailDtoDomainAuthenticationResultDto
 */
export interface WebApiEmailDtoDomainAuthenticationResultDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDomainAuthenticationResultDto
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDomainAuthenticationResultDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the WebApiEmailDtoDomainAuthenticationResultDto interface.
 */
export function instanceOfWebApiEmailDtoDomainAuthenticationResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoDomainAuthenticationResultDtoFromJSON(json: any): WebApiEmailDtoDomainAuthenticationResultDto {
    return WebApiEmailDtoDomainAuthenticationResultDtoFromJSONTyped(json, false);
}

export function WebApiEmailDtoDomainAuthenticationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoDomainAuthenticationResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domainName': !exists(json, 'domain_name') ? undefined : json['domain_name'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WebApiEmailDtoDomainAuthenticationResultDtoToJSON(value?: WebApiEmailDtoDomainAuthenticationResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain_name': value.domainName,
        'message': value.message,
    };
}

